import { Input, Row } from 'antd';
import styled from 'styled-components';

export const CustomPasswordInputWrapper = styled(Input.Password)`
  // height: 36px;
  // border-radius: 6px;
  // padding: 0;

  .ant-input-password-icon svg {
    width: 15px;
  }
`;

export const CustomSearchInputWrapper = styled(Input.Search)``;

export const CustomTextArea = styled(Input.TextArea)``;

export const OtpRow = styled(Row)`
  input {
    text-align: center;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
